var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("AppBar", {
        attrs: { closeModal: _vm.closeModal },
        on: { dadosUsuarioEditar: _vm.editUser, mostrarModal: _vm.open }
      }),
      _c("Recipiente", {
        attrs: { showModal: _vm.showModal, userToEdit: _vm.userToEdit },
        on: { closeModal: _vm.close }
      }),
      _c("FloatModal", {
        attrs: { spec: _vm.floatContent, args: _vm.floatArgs },
        on: { onModalResult: _vm.refreshFloat }
      }),
      _c("v-main", { staticClass: "background" }, [_c("router-view")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }